import { Fragment, useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { useDispatch, useSelector } from 'react-redux'
import Loading from 'components/loading/Loading'
import NoneAnchor from 'components/NoneAnchor'
import { showCampaignDailyBudgetEdit } from 'features/dashboard/operation/campaignDailyBudgetEdit/campaignDailyBudgetEditSlice'
import { fetchDashboardInfoCampaign } from 'features/dashboard/info/dashboardInfoSlice'
import { showCampaignConversionTrackingEdit } from 'features/dashboard/operation/campaignConversionTrackingEdit/campaignConversionTrackingEditSlice'
import {
  CampaignTypeNames,
  CampaignTypes,
  OperationStatus,
} from 'features/Codes'
import Tooltip from 'components/tooltip/Tooltip'
import PropTypes from 'prop-types'
import { equalTo } from 'utils'

const CampaignDashboardTitleTooltip = ({ status }) => {
  const [first] = status
  return first ? (
    <Tooltip
      position="bottom"
      content={status.map((item, index) => (
        <Fragment key={index}>
          <strong className="tit_tooltip">운영 불가({item.title})</strong>
          <p className="txt_tooltip2">{item.msg}</p>
        </Fragment>
      ))}>
      운영 불가({first.title}){status.length > 1 ? `(${status.length})` : ''}
    </Tooltip>
  ) : null
}

CampaignDashboardTitleTooltip.propTypes = {
  status: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      msg: PropTypes.string,
    })
  ),
}

const CampaignInfo = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    visible,
    loaded,
    id: campaignId,
    campaign: { basic, trackInfo, operation },
  } = useSelector(state => state.dashboard.info)
  const operationStatus =
    basic?.operationStatus?.map(_name => OperationStatus[_name]) || []
  const [tabName, setTabName] = useState('basicInfoTab')

  useEffect(() => {
    setTabName('basicInfoTab')
    if (visible && !loaded) {
      dispatch(fetchDashboardInfoCampaign({ id: campaignId }))
    }
  }, [dispatch, visible, loaded, campaignId])

  return (
    <>
      <ul className="tab_g6">
        <li className={tabName === 'basicInfoTab' ? 'on' : ''}>
          <NoneAnchor
            className="link_tab"
            onClick={() => setTabName('basicInfoTab')}>
            기본 정보
          </NoneAnchor>
        </li>
        <li className={tabName === 'operationInfoTab' ? 'on' : ''}>
          <NoneAnchor
            className="link_tab"
            onClick={() => setTabName('operationInfoTab')}>
            운영 정보
          </NoneAnchor>
        </li>
      </ul>
      {isLoading ? (
        <div style={{ height: 296 }}>
          <Loading />
        </div>
      ) : (
        <>
          {tabName === 'basicInfoTab' && loaded && (
            <div className="tab_cont">
              <h4 className="screen_out">기본 정보</h4>
              <div className="infosum_dash">
                <table className="tbl_infosum">
                  <caption className="hide_caption">
                    기본 정보 데이터 테이블
                  </caption>
                  <colgroup>
                    <col />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <div className="inner_cell">ID</div>
                      </th>
                      <td>
                        <div className="inner_cell">{basic.id}</div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <div className="inner_cell">상태</div>
                      </th>
                      <td>
                        <div className="inner_cell">
                          {operationStatus.find(equalTo(OperationStatus.ON)) ? (
                            <>운영 가능</>
                          ) : (
                            <CampaignDashboardTitleTooltip
                              status={operationStatus}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <div className="inner_cell">캠페인 유형</div>
                      </th>
                      <td>
                        <div className="inner_cell">
                          {CampaignTypeNames[basic.type]}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <div className="inner_cell">비즈채널</div>
                      </th>
                      <td>
                        <div className="inner_cell">
                          {basic.bizChannel && (
                            <span className="txt_limit2">
                              {basic.bizChannel.name}
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <div className="inner_cell">일예산</div>
                      </th>
                      <td>
                        <div className="inner_cell">
                          <NoneAnchor
                            className="link_budget"
                            onClick={() =>
                              dispatch(showCampaignDailyBudgetEdit([basic.id]))
                            }>
                            {basic.dailyBudget === null ? (
                              '미설정'
                            ) : (
                              <NumberFormat
                                value={basic.dailyBudget}
                                displayType="text"
                                thousandSeparator
                                suffix="원"
                              />
                            )}
                          </NoneAnchor>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <div className="inner_cell">픽셀&SDK</div>
                      </th>
                      <td>
                        <div className="inner_cell">
                          {trackInfo?.deletedAt && (
                            <Tooltip
                              position="bottom alignLeft"
                              content={
                                <>
                                  해당 캠페인에 설정된 픽셀&SDK가 삭제되어
                                  <br />
                                  더이상 정상적인 전환 추적이 불가합니다.
                                  <br />
                                  캠페인에서 사용 가능한 픽셀&SDK로 변경하세요.
                                </>
                              }>
                              <em className="fc_warn">[삭제됨]</em>&nbsp;
                            </Tooltip>
                          )}
                          <NoneAnchor
                            className="link_budget"
                            onClick={() =>
                              dispatch(
                                showCampaignConversionTrackingEdit({
                                  campaignIds: [basic.id],
                                  hasTalkChannel:
                                    basic.type === CampaignTypes.TALK_CHANNEL,
                                })
                              )
                            }>
                            {trackInfo?.name || '연동하지 않기'}
                          </NoneAnchor>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {isLoading ? (
            <Loading />
          ) : (
            tabName === 'operationInfoTab' &&
            loaded && (
              <div className="tab_cont">
                <h4 className="screen_out">운영 정보</h4>
                <div className="infosum_dash">
                  <table className="tbl_infosum">
                    <caption className="hide_caption">
                      운영 정보 데이터 테이블
                    </caption>
                    <colgroup>
                      <col />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          <div className="inner_cell">광고그룹</div>
                        </th>
                        <td>
                          <div className="inner_cell">
                            운영가능{' '}
                            <NumberFormat
                              value={operation.inOperationAdGroupCount}
                              displayType="text"
                              thousandSeparator
                            />
                            <br />
                            운영불가{' '}
                            <NumberFormat
                              value={operation.notInOperationAdGroupCount}
                              displayType="text"
                              thousandSeparator
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <div className="inner_cell">키워드</div>
                        </th>
                        <td>
                          <div className="inner_cell">
                            심사승인{' '}
                            <NumberFormat
                              value={operation.approvedKeywordCount}
                              displayType="text"
                              thousandSeparator
                            />
                            <br />
                            심사중{' '}
                            <NumberFormat
                              value={operation.approvingKeywordCount}
                              displayType="text"
                              thousandSeparator
                            />
                            <br />
                            심사보류{' '}
                            <NumberFormat
                              value={operation.rejectedApprovalKeywordCount}
                              displayType="text"
                              thousandSeparator
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <div className="inner_cell">소재</div>
                        </th>
                        <td>
                          <div className="inner_cell">
                            심사승인{' '}
                            <NumberFormat
                              value={operation.approvedCreativeCount}
                              displayType="text"
                              thousandSeparator
                            />
                            <br />
                            심사중{' '}
                            <NumberFormat
                              value={operation.approvingCreativeCount}
                              displayType="text"
                              thousandSeparator
                            />
                            <br />
                            심사보류{' '}
                            <NumberFormat
                              value={operation.rejectedApprovalCreativeCount}
                              displayType="text"
                              thousandSeparator
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )
          )}
        </>
      )}
    </>
  )
}

export default CampaignInfo
